import type { FC } from 'react';

import { useIsFeatureVisibleToOrg } from '@/utils/featureFlags';

import { ValueWidgetCloudscape } from './ValueWidget.cloudscape';
import { ValueWidgetHighcharts } from './ValueWidget.highcharts';

type Props = {
  unit?: string;
  loading?: boolean;
  value?: string;
  onClick?: () => void;
  noClickthroughMessageContent?: string;
};

const ValueWidget: FC<Props> = (props) => {
  const highchartsEnabled = useIsFeatureVisibleToOrg('highcharts');

  if (highchartsEnabled) {
    return <ValueWidgetHighcharts {...props} />;
  }

  return <ValueWidgetCloudscape {...props} />;
};

export default ValueWidget;
